import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4dfibacwel: FaireBrandEntity = {
  token: "b_4dfibacwel",
  type: "brand",
  name: "Mountaineers Books",
  avatarUrl: "https://cdn.faire.com/fastly/91567884ea29ccf4eae233e3ce63a65119b75bfc6f34d0b14191e1fe263d8377.png",
  bannerUrl: "https://cdn.faire.com/fastly/74791899b6f66e8bbf6f083c72eb610e630b4719132b81f98859001384f3a4db.png",
  logoUrl: "https://cdn.faire.com/fastly/91567884ea29ccf4eae233e3ce63a65119b75bfc6f34d0b14191e1fe263d8377.png",
  heroImageUrl: "https://cdn.faire.com/fastly/74791899b6f66e8bbf6f083c72eb610e630b4719132b81f98859001384f3a4db.png",
  location: "Seattle, WA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 162,
  isTopShop: true,
  isInsider: true,
  description: "Located in Seattle, WA, and founded in 1960 Mountaineers Books is the nation's leading independent nonprofit publisher of outdoor recreation, lifestyle, and conservation books. We have more than 700 titles in print and distribute the books of other like-minded outdoor publishers.",
  meta: {
    source: "api",
    importedAt: "2026-10-07T18:32:29.108Z",
    importedBy: "entity-db-cli"
  }
};
